
export default {

    common: {
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        add: 'Add',
        search: 'Search',
        filter: 'Filter',
        export: 'Export',
        import: 'Import',
        loading: 'Loading...',
        confirm: 'Confirm',
        back: 'Back',
        next: 'Next',
        previous: 'Previous',
        close: 'Close',
        yes: 'Yes',
        no: 'No',
        all: 'All',
        none: 'None',
        reset: 'Reset',
        apply: 'Apply',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        info: 'Information',
        actions: 'Actions',
        status: 'Status',
        date: 'Date',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        address: 'Address',
        description: 'Description',
        details: 'Details',
        view: 'View',
        download: 'Download',
        upload: 'Upload',
        required: 'Required',
        optional: 'Optional',
        deleting: 'Deleting...',
        send: 'Send',
    },


    nav: {
        dashboard: 'Dashboard',
        loans: 'Loans',
        trading: 'Trading',
        esg: 'ESG',
        waivers: 'Waivers',
        alerts: 'Alerts',
        import: 'Import',
        reports: 'Reports',
        settings: 'Settings',
        help: 'Help',
        profile: 'Profile',
        team: 'Team',
        company: 'Company',
        notifications: 'Notifications',
        roles: 'Roles & Permissions',
        logout: 'Logout',
        mainMenu: 'Main menu',
    },


    esg: {
        title: 'ESG Dashboard',
        subtitle: 'Environmental, Social & Governance metrics for your portfolio',
        greenLoans: 'Green Loans',
        sustainabilityLinked: 'Sustainability-Linked',
        avgEsgScore: 'Avg. ESG Score',
        portfolioAverage: 'Portfolio average',
        esgCompliance: 'ESG Compliance',
        covenantsMet: 'Covenants met',
        environmentalKpis: 'Environmental KPIs',
        carbonIntensity: 'Carbon Intensity',
        renewableEnergy: 'Renewable Energy',
        waterUsage: 'Water Usage',
        wasteRecycling: 'Waste Recycling',
        carbonIntensityTrend: 'Carbon Intensity Trend',
        esgScoreBreakdown: 'ESG Score Breakdown',
        overallEsgScore: 'Overall ESG Score',
        sustainableFinanceAllocation: 'Sustainable Finance Allocation',
        esgCovenants: 'ESG Covenants',
        active: 'active',
        greenSustainabilityLoans: 'Green & Sustainability-Linked Loans',
        lmaGreenLoanPrinciples: 'LMA Green Loan Principles',
        lmaAligned: 'Aligned with LMA\'s Green Loan Principles & Sustainability-Linked Loan Principles',
        learnMore: 'Learn More',
        exportReport: 'Export Report',
        euTaxonomyAligned: 'of portfolio aligned with EU Taxonomy',
        target: 'Target',
        current: 'Current',
        due: 'Due',
        excellent: 'Excellent',
        good: 'Good',
        needsImprovement: 'Needs Improvement',
        compliant: 'Compliant',
        atRisk: 'At Risk',
        environmental: 'Environmental',
        social: 'Social',
        governance: 'Governance',
    },


    import: {
        title: 'Data Import',
        subtitle: 'Import loans, covenants, or financial data',
    },

    notifications: {
        title: 'Notifications',
        subtitle: 'Manage your notification preferences',
    },

    header: {
        notifications: 'Notifications',
        unread: 'Unread',
        criticalAlerts: 'Critical Alerts',
        covenantsInBreach: 'Covenants in Breach',
        covenantsApproachingThreshold: 'Covenants Approaching Threshold',
        noNotifications: 'No notifications',
        settings: 'Settings',
        warnings: 'Warnings',
        help: 'Help',
        myProfile: 'My Account',
        viewAllAlerts: 'View All Alerts',
        logout: 'Logout',
    },


    auth: {
        login: 'Login',
        register: 'Register',
        logout: 'Logout',
        forgotPassword: 'Forgot password?',
        resetPassword: 'Reset password',
        email: 'Email address',
        password: 'Password',
        confirmPassword: 'Confirm password',
        rememberMe: 'Remember me',
        loginButton: 'Sign in',
        registerButton: 'Create account',
        noAccount: 'Don\'t have an account?',
        hasAccount: 'Already have an account?',
        welcomeBack: 'Welcome back! Sign in to your account',
        createAccount: 'Create your account',
        loginSuccess: 'Login successful',
        loginError: 'Incorrect email or password',
        registerSuccess: 'Account created successfully!',
        passwordMismatch: 'Passwords do not match',
        invalidEmail: 'Please enter a valid email',
        passwordTooShort: 'Password must be at least 6 characters',
        demoAccounts: 'Demo accounts',
        selectAccountType: 'Please select an account type',
        firstNameRequired: 'First name is required',
        lastNameRequired: 'Last name is required',
        emailRequired: 'Email is required',
        companyNameRequired: 'Company name is required',
        siretRequired: 'Company ID is required',
        siretInvalid: 'Company ID must contain 14 digits',
        passwordRequired: 'Password is required',
        passwordMinLength: 'Password must be at least 8 characters',
        passwordStrength: 'Password must contain at least one uppercase, one lowercase and one digit',
        termsRequired: 'You must accept the terms of use',
        joinThousands: 'Join thousands of professionals',
        startManaging: 'Create your account and start managing your financial covenants efficiently and securely.',
        accountType: 'Account type',
        accountTypeDesc: 'Business or Individual',
        yourInfo: 'Information',
        yourInfoDesc: 'Your details',
        security: 'Security',
        securityDesc: 'Secure password',
        yourInformation: 'Your information',
        secureAccount: 'Secure your account',
        chooseAccountType: 'Choose your account type',
        companyInfo: 'Your company information',
        personalInfo: 'Your personal details',
        createSecurePassword: 'Create a secure password',
        continue: 'Continue',
        enterprise: 'Enterprise',
        enterpriseDesc: 'For banks, financial institutions and companies',
        multiUsers: 'Multi-users',
        teamManagement: 'Team management',
        advancedReports: 'Advanced reports',
        individual: 'Individual',
        individualDesc: 'For consultants, analysts and freelancers',
        personalAccount: 'Personal account',
        fullAccess: 'Full access',
        siretNumber: 'Company ID',
        position: 'Position',
        weak: 'Weak',
        medium: 'Medium',
        strong: 'Strong',
        veryStrong: 'Very strong',
        atLeast8Chars: 'At least 8 characters',
        oneUppercase: 'One uppercase letter',
        oneLowercase: 'One lowercase letter',
        oneDigit: 'One digit',
        acceptTerms: 'I accept the',
        termsOfUse: 'terms of use',
        and: 'and the',
        privacyPolicy: 'privacy policy',
        creatingAccount: 'Creating account...',
        allRightsReserved: 'All rights reserved.',

        featureRealTime: 'Real-time tracking',
        featureRealTimeDesc: 'Monitor your financial covenants instantly',
        featureAlerts: 'Smart alerts',
        featureAlertsDesc: 'Get notified before potential breaches',
        featureSecurity: 'Enhanced security',
        featureSecurityDesc: 'Your data is protected and encrypted',
        heroTitle: 'Manage your financial covenants with peace of mind',
        heroSubtitle: 'The reference platform for tracking and managing your financial commitments. Anticipate, analyze and act.',
        enterEmail: 'Please enter your email',
        enterPassword: 'Please enter your password',
        copyright: '© 2025 Covenant Tracker. All rights reserved.',

        backToLogin: 'Back to login',
        forgotPasswordTitle: 'Forgot password?',
        forgotPasswordDesc: 'Enter your email address and we will send you a link to reset your password.',
        enterEmailAddress: 'Please enter your email address',
        sendResetLink: 'Send reset link',
        sending: 'Sending...',
        emailSent: 'Email sent!',
        emailSentDesc: 'If an account exists with the address',
        emailSentDesc2: ', you will receive an email with instructions to reset your password.',
        checkSpam: 'Also check your spam folder if you don\'t see the email.',
        demoNote: 'In demo mode, no email is actually sent. Use the test accounts available on the login page.',
        note: 'Note',
    },


    loanDetails: {
        title: 'Loan Details',
        subtitle: 'View and manage loan information',
    },


    dashboard: {
        title: 'Dashboard',
        subtitle: 'Overview of your portfolio',
        totalLoans: 'Total loans',
        totalAmount: 'Total amount',
        activeCovenants: 'Active covenants',
        alertsCount: 'Alerts',
        complianceRate: 'Compliance rate',
        recentAlerts: 'Recent alerts',
        upcomingDeadlines: 'Upcoming deadlines',
        portfolioOverview: 'Portfolio overview',
        covenantStatus: 'Covenant status',
        compliant: 'Compliant',
        atRisk: 'At risk',
        breach: 'Breach',
    },


    loans: {
        title: 'Loan Portfolio',
        subtitle: 'Manage and monitor your loan portfolio',
        addLoan: 'Add Loan',
        editLoan: 'Edit Loan',
        deleteLoan: 'Delete Loan',
        loanDetails: 'Loan Details',
        issues: 'issues',
        borrower: 'Borrower',
        lender: 'Lender',
        leadArranger: 'Lead Arranger',
        amount: 'Amount',
        currency: 'Currency',
        interestRate: 'Interest Rate',
        maturityDate: 'Maturity Date',
        startDate: 'Start Date',
        sector: 'Sector',
        country: 'Country',
        covenants: 'Covenants',
        covenantCount: 'Covenant Count',
        status: 'Status',
        allStatuses: 'All Statuses',
        allSectors: 'All Sectors',
        allCountries: 'All Countries',
        noLoansFound: 'No loans found',
        adjustFilters: 'Try adjusting your search criteria',
        viewDetails: 'View Details',
        exportReport: 'Export Report',
        archive: 'Archive',
        showing: 'Showing',
        to: 'to',
        of: 'of',
        page: 'Page',
        confirmDeleteTitle: 'Delete Loan',
        confirmDeleteMessage: 'Are you sure you want to delete this loan?',
        confirmDeleteWarning: 'This action cannot be undone. All associated covenants, documents, and history will be permanently deleted.',
    },


    loanDetail: {

        previewReport: 'Preview Report',
        preview: 'Preview',
        updateData: 'Update Data',
        exportPdf: 'Export PDF',
        export: 'Export',
        downloaded: 'Downloaded!',

        tabs: {
            overview: 'Overview',
            covenants: 'Covenants',
            history: 'History',
            documents: 'Documents',
            esg: 'ESG',
        },

        esg: {
            title: 'ESG Metrics',
            subtitle: 'Environmental, Social & Governance performance for this loan',
            submitMetrics: 'Submit Metrics',
            covenants: 'ESG Covenants',
            marginAdjustment: 'Margin Adjustment',
            metricsHistory: 'Metrics History',
            period: 'Period',
            esgScore: 'ESG Score',
            status: 'Status',
            verified: 'Verified',
            pending: 'Pending',
            noMetrics: 'No ESG metrics submitted yet',
            clickToSubmit: 'Click the button above to submit your first ESG report',
            latestMetrics: 'Latest Metrics',
            carbonIntensity: 'Carbon Intensity',
            renewableEnergy: 'Renewable Energy',
            waterConsumption: 'Water Consumption',
            genderDiversity: 'Gender Diversity',
            lmaCompliance: 'LMA Compliance',
            lmaDescription: 'This loan follows LMA sustainable finance principles',
            glp: 'Green Loan Principles (GLP)',
            sllp: 'Sustainability-Linked Loan Principles (SLLP)',
            submitMetricsTitle: 'Submit ESG Metrics',
            submitMetricsSubtitle: 'Report your environmental, social and governance performance',
            reportingPeriod: 'Reporting Period',
            overallScores: 'Overall Scores',
            score: 'Score',
            environmentalMetrics: 'Environmental Metrics',
            socialMetrics: 'Social Metrics',
            submitting: 'Submitting...',
            submitSuccess: 'ESG metrics submitted successfully',
            submitError: 'Error submitting ESG metrics',
            tCO2PerMRevenue: 'tCO2/M€ revenue',
            litersPer1000Revenue: 'liters/1000€ revenue',
            ofWorkforce: 'of workforce',
        },

        loanInformation: 'Loan Information',
        leadArranger: 'Lead Arranger',
        maturityDate: 'Maturity Date',
        countrySector: 'Country / Sector',
        nextReporting: 'Next Reporting',

        threshold: 'Threshold',
        headroom: 'headroom',
        aboveMin: 'above min',
        covenantTrends: 'Covenant Trends',
        covenantStatus: 'Covenant Status',
        viewAllCovenants: 'View all {count} covenants',
        allCovenants: 'All Covenants',
        covenantDetails: 'Covenant Details',
        covenant: 'Covenant',
        currentValue: 'Current Value',
        covenantTrendsOverTime: 'Covenant Trends Over Time',

        quickStats: 'Quick Stats',
        totalCovenants: 'Total Covenants',
        compliant: 'Compliant',
        atRisk: 'At Risk',
        breached: 'Breached',
        daysToMaturity: 'Days to Maturity',

        recentAlerts: 'Recent Alerts',
        noRecentAlerts: 'No recent alerts',

        breachHistory: 'Breach History',
        viewFullHistory: 'View full history',
        resolved: 'Resolved',
        active: 'Active',
        breachSummary: 'Breach Summary',
        totalBreaches: 'Total Breaches',
        breachDetails: 'Breach Details',
        value: 'Value',
        vs: 'vs',

        exportOptions: 'Export Options',
        viewBeforeDownload: 'View before downloading',
        quickExport: 'Quick Export',
        downloadPdfDirectly: 'Download PDF directly',
        fullReport: 'Full Report',
        withHistoricalData: 'With historical data',

        activityHistory: 'Activity History',
        completeTimeline: 'Complete timeline of events for this loan',
        allEvents: 'All Events',
        breaches: 'Breaches',
        updates: 'Updates',
        documentsFilter: 'Documents',
        reminders: 'Reminders',
        amendments: 'Amendments',
        timeline: 'Timeline',
        by: 'by',

        documents: 'Documents',
        documentsAssociated: '{count} documents associated with this loan',
        searchDocuments: 'Search documents...',
        allTypes: 'All Types',
        agreements: 'Agreements',
        financial: 'Financial',
        compliance: 'Compliance',
        uploadDocument: 'Upload',
        allDocuments: 'All Documents',
        document: 'Document',
        type: 'Type',
        size: 'Size',
        uploadedBy: 'Uploaded By',
        date: 'Date',
        actions: 'Actions',
        noDocuments: 'No documents found',

        status: {
            compliant: 'Compliant',
            atRisk: 'At Risk',
            breach: 'Breach',
        },

        last6Months: 'Last 6 months',
        last12Months: 'Last 12 months',
        last24Months: 'Last 24 months',
        allStatus: 'All Status',

        updateCovenantData: 'Update Covenant Data',
        updateCovenantValues: 'Update covenant values for this loan',
        newValue: 'New Value',
        notes: 'Notes',
        optionalNotes: 'Optional notes about this update',
        saveChanges: 'Save Changes',
        saving: 'Saving...',
        updateSuccess: 'Covenant values updated successfully',
        updateError: 'Error updating covenant values',

        uploadDocumentTitle: 'Upload Document',
        selectFile: 'Select a file to upload',
        dragAndDrop: 'or drag and drop',
        fileTypes: 'PDF, DOC, DOCX, XLS, XLSX up to 10MB',
        documentName: 'Document Name',
        documentType: 'Document Type',
        selectType: 'Select type',
        agreement: 'Agreement',
        uploading: 'Uploading...',
        uploadSuccess: 'Document uploaded successfully',
        uploadError: 'Error uploading document',
    },


    covenants: {
        title: 'Covenants',
        addCovenant: 'Add Covenant',
        editCovenant: 'Edit Covenant',
        deleteCovenant: 'Delete Covenant',
        type: 'Type',
        threshold: 'Threshold',
        currentValue: 'Current Value',
        targetValue: 'Target Value',
        frequency: 'Frequency',
        nextTest: 'Next Test',
        lastUpdate: 'Last Update',
        updateValue: 'Update Value',
        history: 'History',
        financial: 'Financial',
        nonFinancial: 'Non-Financial',
        affirmative: 'Affirmative',
        negative: 'Negative',
        informational: 'Informational',
    },


    alerts: {
        title: 'Alerts',
        subtitle: 'unread alerts requiring your attention',
        noAlerts: 'No alerts',
        markAsRead: 'Mark as read',
        markAsUnread: 'Mark as unread',
        markAllAsRead: 'Mark all as read',
        resolve: 'Resolve',
        delete: 'Delete',
        unread: 'Unread',
        all: 'All',
        critical: 'Critical',
        warning: 'Warnings',
        info: 'Information',
        severity: 'Severity',
        source: 'Source',
        createdAt: 'Created on',
        totalActive: 'Total active',
        showActive: 'Show active',
        viewArchived: 'View archived',
        archive: 'Archive',
        noArchivedAlerts: 'No archived alerts',
        noAlertsFound: 'No alerts found',
        archivedAlertsWillAppearHere: 'Archived alerts will appear here',
        allCaughtUp: 'You’re all caught up! No alerts require your attention.',
        tryAdjustingFilters: 'Try adjusting your search or filters',
        searchAlerts: 'Search alerts...',
        filters: 'Filters',
        type: 'Type',
        allTypes: 'All types',
        status: 'Status',
        allStatus: 'All statuses',
        read: 'Read',
        category: 'Category',
        allCategories: 'All categories',
        reset: 'Reset',
        selected: 'selected',
        selectedPlural: 'selected',
        viewLoan: 'View loan',
        readAll: 'Read all',
        active: 'Active',
        archived: 'Archived',
        alert: 'Alert',
        loan: 'Loan',
        time: 'Time',
        actions: 'Actions',
        showing: 'Showing',
        of: 'of',
        breach: 'Breach',
        approaching: 'Approaching threshold',
        reporting: 'Reporting',
        maturity: 'Maturity',
        compliance: 'Compliance',
    },


    reports: {
        title: 'Reports',
        subtitle: 'Generate and export your reports',
        generateReport: 'Generate Report',
        scheduleReport: 'Schedule Report',
        reportType: 'Report Type',
        dateRange: 'Date Range',
        format: 'Format',
        portfolio: 'Portfolio',
        compliance: 'Compliance',
        risk: 'Risk',
        custom: 'Custom',
        lastGenerated: 'Last Generated',
        scheduled: 'Scheduled',
        overPeriod: 'over 6 months',
        requiresAction: 'requires action',
        avgMaturity: 'Average Maturity',
        portfolioAvg: 'portfolio average',
        complianceTrend: 'Compliance Trend',
        historicalView: '6-month historical view',
        portfolioStatus: 'Portfolio Status',
        currentDistribution: 'Current distribution',
        exposureBySector: 'Exposure by Sector',
        portfolioAllocation: 'Portfolio allocation',
        alertsTrend: 'Alerts Trend',
        monthlyAlertVolume: 'Monthly alert volume',
        geographicExposure: 'Geographic Exposure',
        topCountries: 'Top countries by value',
        covenantHealthBySector: 'Covenant Health by Sector',
        statusBreakdown: 'Status breakdown',
        topAtRiskLoans: 'Top At-Risk Loans',
        requiresAttention: 'Requiring immediate attention',
        portfolioSummary: 'Portfolio Summary',
        completeOverview: 'Complete overview by sector',
        exportToExcel: 'Export to Excel',
        exposure: 'Exposure',
        percentPortfolio: '% Portfolio',
        noData: 'No data available',
    },


    importPage: {
        title: 'Data Import',
        subtitle: 'Import loans, covenants, or financial updates from CSV or Excel files',
        dragDrop: 'Drag and drop your files here',
        or: 'or',
        browse: 'Browse',
        supportedFormats: 'Supported formats',
        maxSize: 'Maximum size',
        importing: 'Importing...',
        importSuccess: 'Import successful',
        importError: 'Import error',
        preview: 'Preview',
        validate: 'Validate',
        mapping: 'Column mapping',
        import: 'Import',
        importLoans: 'Import Loans',
        importCovenants: 'Import Covenants',
        importFinancialUpdate: 'Import Financial Update',
        loansDescription: 'Import new loans with borrower details, amounts, and maturity dates',
        covenantsDescription: 'Import covenant definitions with thresholds, operators, and current values',
        financialUpdateDescription: 'Update covenant values with new financial reporting data',
        quickStartGuide: 'Quick Start Guide',
        supportedFormatsTitle: 'Supported Formats',
        numberFormatsTitle: 'Number Formats',
        dateFormatsTitle: 'Date Formats',
        excelFormat: 'Excel (.xlsx, .xls)',
        csvFormat: 'CSV (.csv, .txt)',
        europeanNumberFormat: '€1.500.000,50 (European)',
        usNumberFormat: '$1,500,000.50 (US)',
        multiplierFormat: '75M, 1.2B (Multipliers)',
        europeanDateFormat: 'DD/MM/YYYY (European)',
        isoDateFormat: 'YYYY-MM-DD (ISO)',
        textDateFormat: '15 June 2025 (Text)',
        recentImports: 'Recent Imports',
        importsCount: 'imports',
        noImportsYet: 'No imports yet',
        startImporting: 'Start by importing loans, covenants, or financial data',
        imported: 'imported',
        importedPlural: 'imported',
        skipped: 'skipped',
        skippedPlural: 'skipped',
        loans: 'Loans',
        covenants: 'Covenants',
        financialUpdate: 'Financial Update',
    },


    settings: {
        title: 'Settings',
        subtitle: 'Configure your application',
        managePreferences: 'Manage your preferences and application settings',
        general: 'General',
        appearance: 'Appearance',
        notifications: 'Notifications',
        privacy: 'Privacy',
        data: 'Data',
        activityLog: 'Activity Log',
        security: 'Security',
        language: 'Language',
        selectLanguage: 'Select language',
        theme: 'Theme',
        lightTheme: 'Light',
        darkTheme: 'Dark',
        systemTheme: 'System',
        autoTheme: 'Auto',
        timezone: 'Timezone',
        dateFormat: 'Date format',
        numberFormat: 'Number format',
        currency: 'Default currency',

        notificationPreferences: 'Notification Preferences',
        yourPreferences: 'Your preferences',
        emailNotifications: 'Email notifications',
        emailNotificationsDesc: 'Receive alerts by email',
        pushNotifications: 'Push notifications',
        pushNotificationsDesc: 'Notifications in your browser',
        breachAlerts: 'Breach alerts',
        breachAlertsDesc: 'When a covenant is in violation',
        warningAlerts: 'Warning alerts',
        warningAlertsDesc: 'When a covenant approaches threshold',
        weeklyDigest: 'Weekly digest',
        weeklyDigestDesc: 'Receive a summary every Monday',
        globalNotificationConfig: 'Global notification configuration',
        globalNotificationConfigDesc: 'As administrator, you can configure the SMTP server, global alert rules, webhooks and more.',
        configureNotifications: 'Configure notifications',
        alertThresholds: 'Alert thresholds',
        twoFactor: 'Two-factor authentication',
        sessions: 'Active sessions',
        changePassword: 'Change password',
        currentPassword: 'Current password',
        newPassword: 'New password',
        confirmNewPassword: 'Confirm new password',
        savedSuccessfully: 'Settings saved successfully',
        saveError: 'Error saving settings',
        personalPreferences: 'Personal preferences',

        appearanceDisplay: 'Appearance and display',
        display: 'Display',
        compactMode: 'Compact mode',
        compactModeDesc: 'Reduce spacing to display more information',

        privacySecurity: 'Privacy and security',
        profileVisibility: 'Profile visibility',
        public: 'Public',
        publicDesc: 'Visible to all users',
        teamOnly: 'Team',
        teamOnlyDesc: 'Visible only to your team',
        private: 'Private',
        privateDesc: 'Visible only to you',
        otherOptions: 'Other options',
        showActivityStatus: 'Show my activity status',
        showActivityStatusDesc: 'Others can see when you are online',
        shareAnalytics: 'Share usage analytics',
        shareAnalyticsDesc: 'Help us improve the application',

        dataManagement: 'Data management',
        exportYourData: 'Export your data',
        exportYourDataDesc: 'Download a copy of all your data in JSON or CSV format',
        exportData: 'Export data',
        deleteAccount: 'Delete account',
        deleteAccountDesc: 'This action is irreversible. All your data will be permanently deleted.',
        deleteMyAccount: 'Delete my account',

        activityLogTitle: 'Activity log',
        activityLogDesc: 'View all actions and system events',
        total: 'Total',
        last24h: 'Last 24h',
        connections: 'Connections',
        errors24h: 'Errors (24h)',
        allTypes: 'All types',
        allCategories: 'All categories',
        search: 'Search...',
        purge: 'Purge',
        noLogsFound: 'No logs found',
        showingFirst: 'Showing first {count} results out of {total}',
        logDetails: 'Log details',
        user: 'User',
        type: 'Type',
        category: 'Category',
        action: 'Action',
        ipAddress: 'IP Address',
        details: 'Details',
        confirmPurgeLogs: 'Delete logs older than 30 days?',
        logsExported: 'Logs exported as {format}',
        oldLogsDeleted: 'Old logs deleted',

        teamManagement: 'Team management',
        teamManagementDesc: 'Manage your team members and roles',
        manageTeam: 'Manage team',
        accessFullManagement: 'Access full management',
        accessFullManagementDesc: 'Invite new members, manage roles and permissions from the dedicated team management page.',
        teamFeatures: {
            invite: 'Invite members by email',
            roles: 'Assign and modify roles',
            invitations: 'Manage pending invitations',
            activity: 'Track member activity',
        },

        saving: 'Saving...',
        saveChanges: 'Save changes',
        exportPreparing: 'Export preparation in progress...',
    },


    profile: {
        title: 'My Profile',
        subtitle: 'Manage your personal information',
        firstName: 'First name',
        lastName: 'Last name',
        email: 'Email',
        emailNotEditable: 'Not editable',
        phone: 'Phone',
        company: 'Company',
        position: 'Position',
        role: 'Role',
        joinedAt: 'Member since',
        lastActive: 'Last active',
        editProfile: 'Edit profile',
        uploadAvatar: 'Change photo',
        removeAvatar: 'Remove photo',
        accountSettings: 'Account settings',
        updateSuccess: 'Profile updated successfully',
        updateError: 'Failed to update profile',
        informations: 'Information',
        personalInfo: 'Personal information',
        accountInfo: 'Account information',
        createdDate: 'Creation date',
        status: 'Status',
        verifiedAccount: 'Verified account',
        loansManaged: 'Loans managed',
        compliance: 'Compliance',
        changePhoto: 'Change photo',
        selectPhoto: 'Select a photo',
        removePhoto: 'Remove',
        avatarRequirements: 'PNG, JPG or GIF. Max 2 MB.',
        avatarSizeError: 'Image must not exceed 2 MB',
        avatarUpdateSuccess: 'Photo updated successfully',
        avatarUpdateError: 'Failed to update photo',
        avatarRemoved: 'Photo removed',
        passwordHint: 'Choose a strong password with at least 8 characters',
        passwordTooShortError: 'Password must be at least 8 characters',
        passwordMismatchError: 'Passwords do not match',
        passwordChangeSuccess: 'Password changed successfully',
        passwordChangeError: 'Failed to change password',
        changingPassword: 'Changing...',
        currentSession: 'Current session',
        activeNow: 'Active now',
    },


    team: {
        title: 'Team Management',
        subtitle: 'Manage your team members',
        members: 'Members',
        inviteMember: 'Invite Member',
        pendingInvitations: 'Pending Invitations',
        removeMember: 'Remove Member',
        changeRole: 'Change Role',
        active: 'Active',
        inactive: 'Inactive',
        pending: 'Pending',
        inviteByEmail: 'Invite by email',
        sendInvitation: 'Send Invitation',
        invitationSent: 'Invitation sent',
        resendInvitation: 'Resend Invitation',
        cancelInvitation: 'Cancel Invitation',
    },


    roles: {
        title: 'Roles and Permissions',
        subtitle: 'Access rights documentation by role',

        agent: 'Facility Agent',
        agentDesc: 'Full portfolio view, covenant management and platform administration',
        lender: 'Lender',
        lenderDesc: 'Monitor loans and covenants on your syndicate exposures',
        borrower: 'Borrower',
        borrowerDesc: 'Manage your loans, update financial data and reporting',

        admin: 'Administrator',
        adminDesc: 'Full access to all features and settings',
        manager: 'Manager',
        managerDesc: 'Loan management, alerts and team supervision',
        analyst: 'Analyst',
        analystDesc: 'Creation and analysis of loans and covenants',
        viewer: 'Viewer',
        viewerDesc: 'Read-only access to data',
        reader: 'Reader',
        currentRole: 'Your current role',
        permissions: 'permissions',
        permissionMatrix: 'Permission Matrix',
        granted: 'Granted',
        denied: 'Not granted',
        allPermissions: 'All permissions',
        partialPermissions: 'Partial permissions',
        accessRestricted: 'Access restricted',
        noAccessMessage: 'You don\'t have access to this page.',
    },


    lma: {

        facilityTypes: {
            term_loan_a: 'Term Loan A',
            term_loan_b: 'Term Loan B',
            rcf: 'Revolving Credit Facility (RCF)',
            capex: 'Capex Facility',
            acquisition: 'Acquisition Facility',
            green_loan: 'Green Loan',
            sustainability_linked: 'Sustainability-Linked Loan',
            bridge: 'Bridge Facility',
            other: 'Other',
        },

        participantRoles: {
            lead_arranger: 'Lead Arranger',
            co_arranger: 'Co-Arranger',
            bookrunner: 'Bookrunner',
            participant: 'Participant',
            sub_participant: 'Sub-Participant',
        },

        covenantTypes: {
            financial: 'Financial',
            non_financial: 'Non-Financial',
            esg: 'ESG',
            informational: 'Informational',
        },

        covenantCategories: {
            leverage: 'Leverage',
            coverage: 'Coverage',
            liquidity: 'Liquidity',
            capex: 'Capex',
            dividend: 'Dividend',
            esg: 'ESG',
            reporting: 'Reporting',
            other: 'Other',
        },

        covenantNames: {
            debt_ebitda: 'Net Debt / EBITDA',
            interest_coverage: 'Interest Coverage Ratio',
            debt_service: 'Debt Service Coverage Ratio',
            current_ratio: 'Current Ratio',
            min_ebitda: 'Minimum EBITDA',
            max_capex: 'Maximum Capex',
            leverage_ratio: 'Leverage Ratio',
            carbon_intensity: 'Carbon Intensity',
            renewable_energy: 'Renewable Energy %',
        },

        status: {
            compliant: 'Compliant',
            at_risk: 'At Risk',
            breach: 'Breach',
        },

        fields: {
            facilityName: 'Facility Name',
            facilityType: 'Facility Type',
            facilityAmount: 'Facility Amount',
            drawnAmount: 'Drawn Amount',
            availableAmount: 'Available Amount',
            margin: 'Margin',
            referenceRate: 'Reference Rate',
            signingDate: 'Signing Date',
            maturityDate: 'Maturity Date',
            tenorMonths: 'Tenor (Months)',
            nextReportingDate: 'Next Reporting Date',
            reportingFrequency: 'Reporting Frequency',
            leadArranger: 'Lead Arranger',
            syndicate: 'Syndicate Members',
            participation: 'Participation',
            greenLoan: 'Green Loan',
            esgLinked: 'ESG-Linked',
        },

        frequencies: {
            monthly: 'Monthly',
            quarterly: 'Quarterly',
            semi_annual: 'Semi-Annual',
            annual: 'Annual',
        },

        referenceRates: {
            euribor: 'EURIBOR',
            sofr: 'SOFR',
            sonia: 'SONIA',
            libor: 'LIBOR',
        },

        institutionTypes: {
            facility_agent: 'Facility Agent',
            bank: 'Bank',
            corporate: 'Corporate',
            fund: 'Fund',
        },
    },


    permissionCategories: {
        dashboard: 'Dashboard',
        loans: 'Loans',
        covenants: 'Covenants',
        alerts: 'Alerts',
        reports: 'Reports',
        import: 'Data Import',
        team: 'Team',
        settings: 'Settings',
        logs: 'Logs',
    },


    permissions: {
        view_dashboard: 'View dashboard',
        view_dashboard_stats: 'View global statistics',
        view_dashboard_charts: 'View charts',
        view_loans: 'View loans',
        view_loan_details: 'View loan details',
        create_loan: 'Create loan',
        edit_loan: 'Edit loan',
        delete_loan: 'Delete loan',
        archive_loan: 'Archive loan',
        view_covenants: 'View covenants',
        create_covenant: 'Create covenant',
        edit_covenant: 'Edit covenant',
        delete_covenant: 'Delete covenant',
        update_covenant_value: 'Update values',
        view_alerts: 'View alerts',
        manage_alerts: 'Manage alerts',
        configure_alerts: 'Configure alert thresholds',
        delete_alerts: 'Delete alerts',
        view_reports: 'View reports',
        create_report: 'Create reports',
        export_reports: 'Export reports',
        schedule_reports: 'Schedule automatic reports',
        import_data: 'Import data',
        import_bulk: 'Bulk import',
        import_validate: 'Validate imports',
        view_team: 'View team members',
        invite_member: 'Invite members',
        manage_roles: 'Manage roles',
        remove_member: 'Remove members',
        view_settings: 'View settings',
        manage_settings: 'Edit settings',
        manage_company: 'Configure company',
        manage_notifications: 'Configure global notifications',
        manage_integrations: 'Manage integrations',
        view_logs: 'View activity logs',
        export_logs: 'Export logs',
        delete_logs: 'Purge logs',
    },


    companySettings: {
        title: 'Company Settings',
        subtitle: 'Your organization settings',
        companyName: 'Company name',
        legalName: 'Legal name',
        legalNamePlaceholder: 'Full legal name',
        siret: 'Company ID',
        vatNumber: 'VAT number',
        logo: 'Logo',
        uploadLogo: 'Upload logo',
        primaryColor: 'Primary color',
        secondaryColor: 'Secondary color',
        branding: 'Branding',
        billing: 'Billing',
        invoicePrefix: 'Invoice prefix',
        defaultCurrency: 'Default currency',

        generalInfo: 'General information',
        contact: 'Contact details',
        legalInfo: 'Legal information',
        billingSettings: 'Billing settings',

        tradeName: 'Trade name',
        companyDescription: 'Company description',
        descriptionPlaceholder: 'Describe your business...',
        industry: 'Industry',
        companySize: 'Company size',
        foundedYear: 'Founded year',
        website: 'Website',

        addressPlaceholder: 'Street number and name',
        addressLine2: 'Address line 2',
        addressLine2Placeholder: 'Building, floor, etc.',
        postalCode: 'Postal code',
        city: 'City',
        cityPlaceholder: 'City',
        country: 'Country',
        contactEmail: 'Contact email',

        importantInfo: 'Important information',
        legalInfoWarning: 'This information is used for generating legal documents and invoices. Make sure it is accurate and up to date.',
        siretNumber: 'Company ID',
        sirenNumber: 'SIREN number',
        '14digits': '14 digits',
        '9digits': '9 digits',
        rcs: 'Trade registry',
        rcsPlaceholder: 'City B XXX XXX XXX',
        legalForm: 'Legal form',
        apeCode: 'Business activity code',
        shareCapital: 'Share capital',

        billingEmail: 'Billing email',
        paymentTerms: 'Payment terms (days)',
        immediatePayment: 'Immediate payment',
        '15days': '15 days',
        '30days': '30 days',
        '45days': '45 days',
        '60days': '60 days',
        '90days': '90 days',
        billingAddress: 'Billing address',
        billingAddressPlaceholder: 'Full billing address',
        bankDetails: 'Bank details',
        iban: 'IBAN',
        bic: 'BIC/SWIFT',
        bankName: 'Bank name',
        bankNamePlaceholder: 'Your bank name',

        companyLogo: 'Company logo',
        noLogo: 'No logo',
        logoRequirements: 'PNG, JPG or SVG. Max 2 MB. Recommended: 512x512px',
        brandColors: 'Brand colors',
        preview: 'Preview',
        exampleButton: 'Example button',

        saving: 'Saving...',
        saveChanges: 'Save changes',
        logoSizeError: 'Logo must not exceed 2 MB',
        updateSuccess: 'Company information updated successfully. Branding has been applied globally.',

        enterpriseOnly: 'This section is reserved for enterprise accounts. Please upgrade your account to access these features.',
        upgradeToEnterprise: 'Upgrade to Enterprise',

        industries: {
            finance: 'Finance & Banking',
            insurance: 'Insurance',
            consulting: 'Consulting',
            technology: 'Technology',
            healthcare: 'Healthcare',
            manufacturing: 'Manufacturing',
            retail: 'Retail',
            realEstate: 'Real Estate',
            energy: 'Energy',
            other: 'Other',
        },

        sizes: {
            '1-10': '1-10 employees',
            '11-50': '11-50 employees',
            '51-200': '51-200 employees',
            '201-500': '201-500 employees',
            '501-1000': '501-1000 employees',
            '1001-5000': '1001-5000 employees',
            '5001-10000': '5001-10000 employees',
            '10000+': 'More than 10000 employees',
        },

        legalForms: {
            sa: 'Public Limited Company (SA)',
            sas: 'Simplified Joint-Stock Company (SAS)',
            sarl: 'Limited Liability Company (SARL)',
            eurl: 'Single Member LLC (EURL)',
            sca: 'Partnership Limited by Shares (SCA)',
            snc: 'General Partnership (SNC)',
            ei: 'Sole Proprietorship',
            other: 'Other',
        },

        countries: {
            belgium: 'Belgium',
            switzerland: 'Switzerland',
            germany: 'Germany',
            italy: 'Italy',
            spain: 'Spain',
            uk: 'United Kingdom',
            netherlands: 'Netherlands',
            other: 'Other',
        },
    },


    help: {
        title: 'Help Center',
        subtitle: 'Find answers to your questions or contact our support team',
        gettingStarted: 'Getting Started',
        faq: 'FAQ',
        documentation: 'Documentation',
        docDescription: 'Complete application guide',
        support: 'Support',
        contactUs: 'Contact Us',
        contactUsSubtitle: 'Response within 24h',
        tutorials: 'Video Tutorials',
        tutorialsDescription: 'Learn by watching',
        security: 'Security & Legal',
        securitySubtitle: 'Data protection and compliance',
        cgu: 'Terms of Service',
        cguDescription: 'Terms and conditions of use',
        privacy: 'Privacy Policy',
        privacyDescription: 'How we protect your data',
        cookies: 'Cookie Policy',
        cookiesDescription: 'Cookies and trackers management',
        securityPolicy: 'Data Security',
        securityPolicyDescription: 'Our protection measures',
        searchPlaceholder: 'Search in help...',
        noResults: 'No results for',
        clearSearch: 'Clear search',
        quickLinks: 'Quick links',
        apiDocumentation: 'API Documentation',
        apiDescription: 'For developers',
        otherContactMethods: 'Other contact methods',
        systemStatus: 'System status',
        allSystemsOperational: 'All systems operational',
        lastUpdate: 'Last update',
        ago: 'ago',
        min: 'min',
        categories: {
            gettingStarted: 'Getting Started',
            loans: 'Loan Management',
            covenants: 'Covenants',
            alerts: 'Alerts',
            reports: 'Reports',
            import: 'Data Import',
            users: 'Users',
            settings: 'Settings',
        },
        contactForm: {
            subject: 'Subject',
            subjectPlaceholder: 'Your question...',
            priority: 'Priority',
            priorityLow: 'Low',
            priorityNormal: 'Normal',
            priorityHigh: 'High',
            priorityUrgent: 'Urgent',
            message: 'Message',
            messagePlaceholder: 'Describe your issue...',
            send: 'Send',
            sending: 'Sending...',
            success: 'Your message has been sent. We will respond within 24h.',
            error: 'Please fill in all fields',
            errorGeneric: 'An error occurred while sending the message. Please try again.',
        },
        emailLabel: 'Email',
        emailAddress: 'support@covenant-tracker.com',
        phoneLabel: 'Phone',
        phoneNumber: '+33 1 23 45 67 89',
        phoneHours: 'Mon-Fri, 9am-6pm',
        understood: 'I understand',
        lastUpdated: 'Last updated',
        lastUpdatedDate: 'January 1, 2025',
        gdprCompliant: 'GDPR Compliant',
        encryption: 'AES-256 Encryption',
        euHosting: 'EU Hosting',
        twoFactorAvailable: '2FA available',

        modals: {
            cgu: {
                title: 'Terms of Use',
                lastUpdated: 'Last updated',
                lastUpdatedDate: 'January 1, 2025',
                section1Title: '1. Purpose',
                section1Content: 'These Terms of Use (ToU) govern access to and use of the Covenant Tracker application, published by Covenant Tracker SAS. By accessing the application, you agree to these ToU without reservation.',
                section2Title: '2. Service Description',
                section2Content: 'Covenant Tracker is a financial covenant management and tracking application. It allows users to:',
                section2List: ['Create and manage loans and their associated covenants', 'Track financial indicators in real-time', 'Receive alerts when thresholds are exceeded', 'Generate reports and analyses'],
                section3Title: '3. Access to Service',
                section3Content: 'Access to the service requires the creation of a user account. You are responsible for the confidentiality of your credentials and all activities performed under your account.',
                section4Title: '4. User Obligations',
                section4Content: 'The user agrees to:',
                section4List: ['Provide accurate and up-to-date information', 'Not use the service for unlawful purposes', 'Respect intellectual property rights', 'Not attempt to compromise the security of the service'],
                section5Title: '5. Intellectual Property',
                section5Content: 'All elements constituting the application (software, databases, texts, images, etc.) are the exclusive property of Covenant Tracker SAS and are protected by intellectual property laws.',
                section6Title: '6. Limitation of Liability',
                section6Content: 'Covenant Tracker shall not be held liable for direct or indirect damages resulting from the use or inability to use the service. The data presented is provided for informational purposes only.',
                section7Title: '7. Modification of ToU',
                section7Content: 'Covenant Tracker reserves the right to modify these ToU at any time. Users will be notified of any changes by notification in the application.',
                section8Title: '8. Applicable Law',
                section8Content: 'These ToU are governed by French law. Any dispute shall be submitted to the exclusive jurisdiction of the Paris courts.',
            },
            privacy: {
                title: 'Privacy Policy',
                lastUpdated: 'Last updated',
                lastUpdatedDate: 'January 1, 2025',
                section1Title: '1. Data Controller',
                section1Content: 'Covenant Tracker SAS, a simplified joint-stock company with a capital of 50,000 euros, headquartered at 16 Boulevard des Italiens, 75009 Paris, France.',
                section1Email: 'Email: privacy@covenant-tracker.com',
                section2Title: '2. Data Collected',
                section2Content: 'We collect the following categories of data:',
                section2List: ['Identification data: name, first name, email, phone', 'Professional data: company, position, industry sector', 'Financial data: information on loans and covenants', 'Connection data: logs, IP address, browser type'],
                section3Title: '3. Processing Purposes',
                section3Content: 'Your data is processed for:',
                section3List: ['Managing your user account', 'Providing and improving our services', 'Sending notifications and alerts', 'Compliance with our legal obligations', 'Statistical analysis and improving user experience'],
                section4Title: '4. Legal Basis',
                section4Content: 'The processing of your data is based on:',
                section4List: ['Performance of the service contract', 'Your consent (for non-essential cookies)', 'Our legitimate interest (service improvement)', 'Compliance with legal obligations'],
                section5Title: '5. Retention Period',
                section5Content: 'Your data is retained for the duration of your use of the service, then for a period of 3 years after the end of the business relationship, unless a longer legal retention period applies.',
                section6Title: '6. Your Rights',
                section6Content: 'In accordance with GDPR, you have the following rights:',
                section6List: ['Right of access: obtain a copy of your data', 'Right to rectification: correct your inaccurate data', 'Right to erasure: request the deletion of your data', 'Right to portability: receive your data in a structured format', 'Right to object: object to the processing of your data', 'Right to restriction: limit the processing of your data'],
                section6Contact: 'To exercise these rights: privacy@covenant-tracker.com',
                section7Title: '7. Data Transfers',
                section7Content: 'Your data is hosted within the European Union. In case of transfer to a third country, appropriate safeguards will be implemented in accordance with GDPR.',
                section8Title: '8. Complaint',
                section8Content: 'You can file a complaint with the CNIL (Commission Nationale de l\'Informatique et des Libertés): www.cnil.fr',
            },
            cookies: {
                title: 'Cookie Policy',
                lastUpdated: 'Last updated',
                lastUpdatedDate: 'January 1, 2025',
                section1Title: '1. What is a cookie?',
                section1Content: 'A cookie is a small text file placed on your device (computer, tablet, smartphone) when you visit a website. It stores information related to your browsing.',
                section2Title: '2. Types of Cookies Used',
                essential: 'Essential Cookies (mandatory)',
                essentialDesc: 'These cookies are necessary for the application to function. They enable authentication, security, and storing your preferences.',
                essentialList: ['User session', 'Authentication token', 'Language preferences'],
                analytics: 'Analytics Cookies (optional)',
                analyticsDesc: 'These cookies help us understand how you use the application to improve our services.',
                analyticsList: ['Pages visited', 'Session duration', 'Features used'],
                personalization: 'Personalization Cookies (optional)',
                personalizationDesc: 'These cookies allow us to personalize your experience by remembering your preferences.',
                personalizationList: ['Theme (light/dark)', 'Dashboard layout', 'Preferred filters and views'],
                section3Title: '3. Retention Period',
                cookieType: 'Cookie type',
                duration: 'Duration',
                session: 'Session',
                sessionDuration: 'Until browser is closed',
                authentication: 'Authentication',
                authDuration: '30 days (if "Remember me")',
                preferences: 'Preferences',
                prefDuration: '1 year',
                analyticsDuration: '13 months',
                section4Title: '4. Manage Your Preferences',
                section4Content: 'You can change your cookie preferences at any time in the application Settings, under the "Privacy" section.',
                section4Content2: 'You can also configure your browser to refuse cookies. Note that some features may no longer be available.',
            },
            security: {
                title: 'Data Security',
                priority: 'The security of your financial data is our absolute priority.',
                encryption: 'Data Encryption',
                encryptionTransit: 'In transit: All communications are encrypted via TLS 1.3',
                encryptionRest: 'At rest: AES-256 encryption for all stored data',
                encryptionPasswords: 'Passwords: bcrypt hashing with individual salt',
                authentication: 'Authentication',
                twoFactor: '2FA: Two-factor authentication available (TOTP, SMS)',
                sessions: 'Sessions: Automatic expiration and remote revocation',
                detection: 'Detection: Alerts on suspicious login attempts',
                infrastructure: 'Infrastructure',
                euHosting: 'EU Hosting: Servers located in France and Germany',
                backups: 'Backups: Daily encrypted backups, 30-day retention',
                availability: 'Availability: 99.9% SLA with 24/7 monitoring',
                ddos: 'DDoS: Protection against denial of service attacks',
                compliance: 'Compliance & Audits',
                gdpr: 'GDPR: Full compliance with European regulation',
                audits: 'Audits: Annual penetration tests by independent experts',
                logs: 'Logs: Complete logging of access and modifications',
                reportVulnerability: 'Report a Vulnerability',
                reportVulnerabilityContent: 'If you discover a security flaw, please contact us immediately at:',
            },
        },
        faqContent: {
            gettingStarted: [
                {
                    question: "How do I create my first loan?",
                    answer: "To create a loan, go to the 'Loans' page from the sidebar, then click the 'New Loan' button. Follow the 4-step wizard to enter basic information, loan details, define covenants, and validate."
                },
                {
                    question: "What is a covenant?",
                    answer: "A covenant is a contractual clause in a loan agreement that imposes certain conditions on the borrower. It can be financial ratios to maintain (e.g., debt/EBITDA ratio below 3x), minimum thresholds (e.g., liquidity ratio above 1.2), or reporting obligations."
                },
                {
                    question: "How do I navigate the application?",
                    answer: "Use the sidebar on the left to access different sections: Dashboard for an overview, Loans to manage your loans, Alerts to track notifications, Reports for analysis, and Import to add data."
                },
            ],
            loans: [
                {
                    question: "How do I modify an existing loan?",
                    answer: "From the Loans page, click the three dots (...) on the right of the loan and select 'Edit'. You can also access loan details by clicking on it, then use the 'Edit' button at the top of the page."
                },
                {
                    question: "Can I delete a loan?",
                    answer: "Yes, you can delete a loan from the actions menu (...). Warning: this action is irreversible and will also delete all associated covenants and history. A confirmation will be requested."
                },
                {
                    question: "How do I filter loans by status?",
                    answer: "On the Loans page, use the filters at the top of the list. You can filter by status (Compliant, At Risk, Breach), by industry sector, by country, or use the search bar to find a specific loan."
                },
            ],
            covenants: [
                {
                    question: "How do I add a covenant to a loan?",
                    answer: "When creating a loan, step 3 allows you to define covenants. You can choose from predefined templates or create custom covenants. For an existing loan, edit it and access the covenants section."
                },
                {
                    question: "How are covenant statuses calculated?",
                    answer: "The status is automatically calculated by comparing the current value to the defined threshold, according to the chosen operator (>, <, >=, <=). A covenant is 'Compliant' if the condition is met, 'At Risk' if approaching the threshold (within 10%), and 'Breach' if the condition is not met."
                },
                {
                    question: "What types of covenants can I create?",
                    answer: "You can create ratio-type covenants (e.g., Debt/EBITDA), absolute value (e.g., minimum EBITDA), or percentage (e.g., operating margin). Each covenant can have a custom comparison operator and threshold."
                },
            ],
            alerts: [
                {
                    question: "How do I configure my notifications?",
                    answer: "Go to Settings > Notifications to configure your preferences. You can choose to receive email and/or push alerts, define alert types (breach, warning, reporting) and enable the weekly digest."
                },
                {
                    question: "What do the different alert types mean?",
                    answer: "Alerts are classified into three categories: Critical (red) for covenant breaches, Warning (orange) for values approaching thresholds, and Information (blue) for reporting reminders and other notifications."
                },
                {
                    question: "How do I mark an alert as handled?",
                    answer: "Click on the alert to see its details, then use the 'Mark as read' or 'Archive' button. Archived alerts remain viewable in the 'Archived' tab of the Alerts page."
                },
            ],
            reports: [
                {
                    question: "How do I generate a report?",
                    answer: "Go to the Reports page and select the desired report type (Compliance, Performance, Trends). Configure filters and period, then click 'Generate'. You can then export the report as PDF or Excel."
                },
                {
                    question: "Can I customize reports?",
                    answer: "Yes, each report type offers customization options. You can choose which metrics to display, the analysis period, which loans to include, and the export format (PDF, Excel)."
                },
                {
                    question: "How do I schedule automatic reports?",
                    answer: "In Settings > Notifications, enable the 'Weekly Digest' option to automatically receive a summary report every Monday. More advanced automatic report options are available for Enterprise accounts."
                },
            ],
            import: [
                {
                    question: "What file formats are supported?",
                    answer: "The application supports CSV and Excel (XLSX) formats. Files must follow a specific format with required columns. A template can be downloaded from the Import page."
                },
                {
                    question: "How do I resolve import errors?",
                    answer: "If the import fails, check that your file follows the expected format (columns, data types). The most common errors are missing columns, incorrect date formats, or poorly formatted numeric values."
                },
                {
                    question: "Can I update existing data?",
                    answer: "Yes, during import, you can choose to update existing loans (based on loan reference) or create only new records. Duplicates are automatically detected."
                },
            ],
            users: [
                {
                    question: "How do I invite a new team member?",
                    answer: "Go to Settings > Team (available for administrators and managers), then click 'Invite'. Enter the new member's email and select their role. They will receive an invitation email."
                },
                {
                    question: "What are the different roles available?",
                    answer: "There are 4 roles: Admin (full access), Manager (team and loan management), Analyst (creation and analysis), and Viewer (read-only). Each role has specific permissions detailed in Settings > Team."
                },
                {
                    question: "How do I change a user's role?",
                    answer: "In Settings > Team, click on the member and modify their role in the dropdown menu. Only administrators can modify other users' roles."
                },
            ],
            settings: [
                {
                    question: "How do I change the application language?",
                    answer: "Go to Settings > Appearance and select your preferred language from the dropdown menu. The application currently supports French, English, German, and Spanish."
                },
                {
                    question: "How do I enable dark mode?",
                    answer: "In Settings > Appearance, choose 'Dark' in the Theme section. You can also select 'System' to automatically follow your device preferences."
                },
                {
                    question: "How do I export my data?",
                    answer: "Go to Settings > Data and click 'Export Data'. You will receive a ZIP file containing all your data in JSON format, including loans, covenants, alerts, and history."
                },
            ],
        },
    },


    errors: {
        notFound: 'Page not found',
        notFoundMessage: 'The page you are looking for does not exist or has been moved.',
        unauthorized: 'Unauthorized access',
        unauthorizedMessage: 'You don\'t have permission to access this page.',
        serverError: 'Server error',
        serverErrorMessage: 'An unexpected error occurred. Please try again later.',
        backToHome: 'Back to home',
        goBack: 'Go back',
    },


    confirmations: {
        deleteTitle: 'Confirm deletion',
        deleteMessage: 'Are you sure you want to delete this item? This action cannot be undone.',
        logoutTitle: 'Logout',
        logoutMessage: 'Are you sure you want to logout?',
        unsavedChanges: 'You have unsaved changes. Do you really want to leave?',
    },


    dateTime: {
        today: 'Today',
        yesterday: 'Yesterday',
        tomorrow: 'Tomorrow',
        thisWeek: 'This week',
        lastWeek: 'Last week',
        thisMonth: 'This month',
        lastMonth: 'Last month',
        last3Months: 'Last 3 months',
        last6Months: 'Last 6 months',
        thisYear: 'This year',
        lastYear: 'Last year',
        daysAgo: '{count} days ago',
        hoursAgo: '{count} hours ago',
        minutesAgo: '{count} minutes ago',
        justNow: 'Just now',
    },


    formats: {
        date: 'MM/DD/YYYY',
        dateTime: 'MM/DD/YYYY HH:mm',
        time: 'HH:mm',
        currency: '{currency}{amount}',
        percentage: '{value}%',
    },


    team: {
        title: 'Team Management',
        subtitle: 'Manage your team members',
        members: 'Members',
        invitations: 'Invitations',
        inviteMember: 'Invite a member',
        pendingInvitations: 'pending invitations',
        membersCount: 'member',
        membersCountPlural: 'members',
        searchPlaceholder: 'Search...',
        you: 'You',
        memberSince: 'Member since',
        online: 'Online',
        minutesAgo: 'ago min',
        hoursAgo: 'h ago',
        daysAgo: 'd ago',
        noMembersFound: 'No members found',
        noInvitations: 'No pending invitations',
        availableRoles: 'Available roles',
        editRole: 'Edit role',
        removeFromTeam: 'Remove from team',
        invitedBy: 'Invited by',
        expiresOn: 'Expires on',
        invitationExpired: 'Invitation expired',
        resend: 'Resend',
        cancelInvitation: 'Cancel',
        inviteModal: {
            title: 'Invite a member',
            emailLabel: 'Email address *',
            emailPlaceholder: 'colleague@company.com',
            roleLabel: 'Assigned role *',
            messageLabel: 'Custom message (optional)',
            messagePlaceholder: 'Add a message to the invitation...',
            cancel: 'Cancel',
            send: 'Send invitation',
            sending: 'Sending...',
        },
        editRoleModal: {
            title: 'Edit role',
            current: 'Current',
        },
        deleteModal: {
            title: 'Remove team member',
            message: 'Are you sure you want to remove this member from the team?',
            warning: 'This action cannot be undone. The user will lose access to all team resources.',
            confirm: 'Remove',
        },
        messages: {
            validEmailRequired: 'Please enter a valid email',
            alreadyMember: 'This user is already a team member',
            invitationPending: 'An invitation is already pending for this email',
            invitationSent: 'Invitation sent to',
            roleUpdated: 'Role updated successfully',
            memberRemoved: 'Member removed from team',
            invitationCancelled: 'Invitation cancelled',
            invitationResent: 'Invitation resent',
        },
        emailInvalid: 'Please enter a valid email',
        userAlreadyMember: 'This user is already a team member',
        invitationAlreadyPending: 'An invitation is already pending for this email',
        invitationSentTo: 'Invitation sent to',
        roleUpdatedSuccess: 'Role updated successfully',
        memberRemovedSuccess: 'Member removed from team',
        invitationCancelledSuccess: 'Invitation cancelled',
        invitationResentSuccess: 'Invitation resent',
        confirmRemove: 'Are you sure you want to remove this member from the team?',
        cancel: 'Cancel',
    },


    unauthorized: {
        title: 'Unauthorized Access',
        message: 'You do not have the required permissions to access this page. Contact your administrator if you believe this is an error.',
        backToDashboard: 'Back to Dashboard',
        previousPage: 'Previous Page',
    },


    rolesPermissions: {
        title: 'Roles & Permissions',
        subtitle: 'Complete documentation of access rights by role',
        restrictedAccess: 'Restricted Access',
        noAccessMessage: 'You do not have access to the roles and permissions documentation.',
        yourCurrentRole: 'Your current role',
        youHave: 'You have',
        permissionsOf: 'permissions out of',
        available: 'available',
        you: 'You',
        permissionMatrix: 'Permission Matrix',
        permissionMatrixDesc: 'Comparison of access by role and category',
        permission: 'Permission',
        legend: 'Legend',
        permissionGranted: 'Permission granted',
        permissionDenied: 'Permission not granted',
        allPermissions: 'All category permissions',
        partialPermissions: 'Partial permissions',
    },


    trading: {
        title: 'Secondary Trading',
        subtitle: 'Loan participation marketplace - Buy and sell syndicated loan positions',
        newOrder: 'New Order',
        refresh: 'Refresh',
        openOrders: 'Open Orders',
        tradeHistory: 'Trade History',
        buy: 'Buy',
        sell: 'Sell',
        all: 'All',
        amount: 'Amount',
        price: 'Price',
        expires: 'Expires',
        borrower: 'Borrower',
        facility: 'Facility',
        seller: 'Seller',
        buyer: 'Buyer',
        date: 'Date',
        settled: 'Settled',
        noOrders: 'No open orders',
        searchPlaceholder: 'Search by borrower or facility...',
        buyFrom: 'Buy',
        sellTo: 'Sell',
        orderType: 'Order Type',
        selectLoan: 'Select Loan',
        chooseLoan: 'Choose a loan...',
        participationAmount: 'Participation Amount',
        pricePercent: 'Price (%)',
        priceHint: '100% = par value. Below 100 = discount, above 100 = premium',
        validFor: 'Valid For',
        day: 'day',
        days: 'days',
        placeOrder: 'Place Order',
        status: {
            open: 'Open',
            matched: 'Matched',
            cancelled: 'Cancelled',
            expired: 'Expired',
        },
        stats: {
            openOrders: 'Open Orders',
            tradedVolume: 'Traded Volume (30d)',
            avgPrice: 'Avg. Price',
            activeParticipants: 'Active Participants',
        },
        marketInfo: {
            title: 'European Leveraged Loan Market',
            subtitle: 'Real-time market data from LMA members',
            weeklyVolume: 'Weekly Volume',
            weeklyChange: 'vs. Last Week',
        },
    },


    notificationSettings: {
        title: 'Notification Settings',
        subtitle: 'Configure emails, alerts and notification integrations',
        restricted: {
            title: 'Restricted Access',
            message: 'Only administrators can access notification settings.',
        },
        tabs: {
            smtp: 'SMTP Configuration',
            alerts: 'Alert Rules',
            templates: 'Email Templates',
            webhooks: 'Webhooks',
            advanced: 'Advanced',
        },
        status: {
            title: 'Configuration Status',
            enabled: 'enabled',
            disabled: 'disabled',
            enabledFem: 'enabled',
            disabledFem: 'disabled',
        },
        messages: {
            saved: 'Configuration saved successfully',
            enterEmail: 'Please enter an email address',
            webhookRequired: 'Please fill in the webhook name and URL',
            webhookAdded: 'Webhook added successfully',
            configReset: 'Configuration reset',
        },
        smtp: {
            title: 'SMTP Configuration',
            subtitle: 'Mail server settings',
            server: 'SMTP Server',
            host: 'SMTP Host',
            port: 'Port',
            portUnsecured: 'Unsecured',
            recommended: 'Recommended',
            alternate: 'Alternate',
            secureConnection: 'Secure Connection (SSL/TLS)',
            secureConnectionDesc: 'Recommended for data security',
            authentication: 'Authentication',
            username: 'Username',
            password: 'Password',
            sender: 'Sender',
            senderEmail: 'Sender Email',
            displayName: 'Display Name',
            replyTo: 'Reply-To Email',
            replyToPlaceholder: 'support@example.com (optional)',
            testConfig: 'Test Configuration',
            testConnection: 'Test Connection',
            testEmailPlaceholder: 'Test Email',
            popularPresets: 'Popular Presets',
        },
        alerts: {
            title: 'Alerts',
            rulesTitle: 'Alert Rules',
            enableAlerts: 'Enable Alerts',
            enableAlertsDesc: 'Enable/disable all alert notifications',
            alertTypes: 'Alert Types',
            breach: 'Breach (Critical)',
            breachDesc: 'Covenant threshold exceeded',
            warning: 'Warning',
            warningDesc: 'Approaching threshold (10%)',
            info: 'Info (Information)',
            infoDesc: 'Reminders and general notifications',
            channels: 'Channels by Alert Type',
            timing: 'Notification Timing',
            immediateAlerts: 'Immediate Notifications',
            immediateAlertsDesc: 'Send alerts as soon as they are detected',
            digest: 'Digest (grouping)',
            digestDesc: 'Group non-urgent alerts',
            hourly: 'Hourly',
            daily: 'Daily',
            weekly: 'Weekly',
            quietHours: 'Quiet Hours',
            enableQuietHours: 'Enable Quiet Hours',
            enableQuietHoursDesc: 'Do not send notifications during certain hours',
            from: 'From',
            to: 'to',
            excludeUrgent: 'Exclude Urgent Alerts (Breach)',
            excludeUrgentDesc: 'Always send critical alerts',
            autoReports: 'Automatic Reports',
            weeklyReport: 'Weekly Report',
            weeklyReportDesc: 'Covenant summary every week',
            monthlyReport: 'Monthly Report',
            monthlyReportDesc: 'Detailed analysis every month',
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
        },
        templates: {
            title: 'Email Templates',
            customization: 'Customization',
            useCompanyBranding: 'Use Company Branding',
            useCompanyBrandingDesc: 'Apply company logo and colors',
            headerColor: 'Header Color',
            footerText: 'Footer Text',
            unsubscribeLink: 'Include Unsubscribe Link',
            unsubscribeLinkDesc: 'Required by GDPR',
            preview: 'Preview',
            previewGreeting: 'Hello,',
            previewContent: 'This is a preview of your notification emails...',
        },
        webhooks: {
            title: 'Webhooks',
            subtitle: 'External service integrations',
            noWebhooks: 'No webhooks configured',
            newWebhook: 'New Webhook',
            name: 'Name',
            url: 'URL',
            events: 'Events',
            secret: 'Secret (for HMAC signature)',
            secretPlaceholder: 'Optional',
            generate: 'Generate',
            add: 'Add',
            addWebhook: 'Add a Webhook',
        },
        advanced: {
            title: 'Advanced Settings',
            limits: 'Notification Limits',
            maxEmailsPerDay: 'Max Emails per Day',
            maxPushPerHour: 'Max Push per Hour',
            logging: 'Logging',
            enableLogs: 'Enable Send Logs',
            enableLogsDesc: 'Keep a history of sent notifications',
            logRetention: 'Log Retention (days)',
            dangerZone: 'Danger Zone',
            dangerZoneDesc: 'Reset all notification settings to their default values.',
            resetConfig: 'Reset',
            confirmReset: 'Are you sure you want to reset all settings?',
        },
        save: 'Save',
        saving: 'Saving...',
    },


    waivers: {
        title: 'Covenant Waivers',
        subtitle: 'Manage covenant waiver requests and approvals',
        newRequest: 'New Waiver Request',
        searchPlaceholder: 'Search by borrower, covenant, or ID...',
        allStatus: 'All Statuses',
        totalRequests: 'Total Requests',
        pendingReview: 'Pending Review',
        underVoting: 'Under Voting',
        approved: 'Approved',
        rejected: 'Rejected',
        noWaivers: 'No waiver requests found',
        noWaiversDescription: 'Start by creating a new waiver request or adjust your filters',

        status: {
            draft: 'Draft',
            pending_review: 'Pending Review',
            negotiating: 'Negotiating',
            under_voting: 'Under Voting',
            approved: 'Approved',
            rejected: 'Rejected',
            expired: 'Expired',
            withdrawn: 'Withdrawn',
        },

        current: 'Current',
        threshold: 'Threshold',
        votingProgress: 'Voting Progress',
        approval: 'Approval',
        requiredMajority: 'Required Majority',
        deadline: 'Deadline',

        approve: 'Approve',
        reject: 'Reject',
        for: 'For',
        against: 'Against',
        received: 'Received',
        pendingVotes: 'pending votes',
        votingStatus: 'Voting Status',

        selectLoan: 'Select Loan',
        selectLoanPlaceholder: 'Select a loan...',
        covenantName: 'Covenant Name',
        covenantType: 'Covenant Type',
        currentValue: 'Current Value',
        thresholdValue: 'Threshold Value',
        requestedWaiver: 'Requested Waiver',
        justification: 'Justification',
        justificationPlaceholder: 'Explain why this waiver is needed and the expected recovery plan...',
        supportingDocuments: 'Supporting Documents',
        dragDropFiles: 'Drag & drop files or click to browse',
        saveDraft: 'Save Draft',
        submitForReview: 'Submit for Review',

        types: {
            financial: 'Financial',
            operational: 'Operational',
            reporting: 'Reporting',
            other: 'Other',
        },

        simpleMajority: 'Simple Majority',
        superMajority: 'Super Majority',
        qualifiedMajority: 'Qualified Majority',
        unanimity: 'Unanimity',

        covenantDetails: 'Covenant Details',
        comments: 'Comments',
        noComments: 'No comments yet',
        addCommentPlaceholder: 'Add a comment...',
        timeline: 'Timeline',
        requestCreated: 'Request Created',
        votingDeadline: 'Voting Deadline',
        requestInfo: 'Request Information',
        requestedBy: 'Requested By',
        totalLenders: 'Total Lenders',

        agentAction: 'Agent Action Required',
        agentReviewMessage: 'Review this waiver request and decide whether to open it for lender voting.',
        openForVoting: 'Open for Voting',
        requestMoreInfo: 'Request More Info',

        tabs: {
            details: 'Details',
            negotiation: 'Negotiation',
        },

        negotiation: {
            title: 'Negotiation History',
            round: 'Round',
            initialProposal: 'Initial Proposal',
            counterProposal: 'Counter-Proposal',
            current: 'Current',
            superseded: 'Superseded',
            conditions: 'Conditions',
            accept: 'Accept',
            counter: 'Counter',
            makeCounter: 'Make Counter-Proposal',
            yourProposal: 'Your Proposal',
            proposalPlaceholder: 'Describe your counter-proposal...',
            condition: 'Condition',
            addCondition: 'Add condition',
            submitCounter: 'Submit Counter-Proposal',
            agentMessage: 'Once parties agree on terms, you can finalize and open for formal voting.',
            finalizeAndVote: 'Finalize & Open Voting',
        },
    },
};
